import { render } from "./change-password-modal.template.html?vue&type=template&id=3b0acc40&scoped=true"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=ts"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=3b0acc40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b0acc40"

export default script